export const StudentQuizResultTranslations = {
  QUIZ_RESULT: {
    es: 'Resultado del examen',
    en: 'Quiz Result',
    cat: 'Resultat del quiz',
    eus: 'Quizaren emaitza',
    pt: 'Resultado do quiz'
  },
  SEE_RESULTS: {
    es: 'Ver resultados',
    en: 'See results',
    cat: 'Veure resultats',
    eus: 'Ikusi emaitzak',
    pt: 'Ver resultados'
  },
  EXIT: {
    es: 'Salir',
    en: 'Exit',
    cat: 'Sortir',
    eus: 'Etzana',
    pt: 'Sair'
  },
  GOOD_QUIZZ_RESULT_1: {
    es: '¡Gran trabajo!',
    en: '¡Great job!',
    cat: '¡Gran treball!',
    eus: '¡Orokorra!',
    pt: '¡Muito bem!'
  },

  GOOD_QUIZZ_RESULT_2: {
    es: '¡Vaya crack!',
    en: 'What a champ!',
    cat: '¡Ets un crack!',
    eus: '¡Ze pro!',
    pt: '¡Que fera!'
  },

  GOOD_QUIZZ_RESULT_3: {
    es: '¡Brillante!',
    en: '¡Brilliant!',
    cat: '¡Brillant!',
    eus: '¡Egiaztatu dugu!',
    pt: '¡Excelente!'
  },

  GOOD_QUIZZ_RESULT_4: {
    es: '¡Wow lo has bordado!',
    en: '¡Wow you nailed it!',
    cat: '¡Uau, ho has bordat!',
    eus: '¡Wau, lehenengo egin duzu!',
    pt: '¡Uau, você acertou!'
  },

  GOOD_QUIZZ_RESULT_5: {
    es: '¡Felicidades!',
    en: '¡Congratulations!',
    cat: '¡Enhorabona!',
    eus: '¡Eskubidez!',
    pt: '¡Parabéns!'
  },

  GOOD_QUIZZ_RESULT_SUBTITLE_1: {
    es: '¡Estás superando límites. ¡Vamos por más!',
    en: '¡You are exceeding limits. ¡Let’s go for more!!',
    cat: '¡Estàs superant límits. ¡Vam a fer més!!',
    eus: '¡Mugak gainditzen ari zara. Goazen gehiagoren bila!',
    pt: '¡Está a ultrapassar limites. Vamos em busca de mais!'
  },

  GOOD_QUIZZ_RESULT_SUBTITLE_2: {
    es: '¡Continúa así y la meta estará cada vez más cerca.',
    en: '¡Keep trying and you will get better and better. 💪',
    cat: '¡Segueix esforçant-te i ho faràs cada vegada millor. 💪',
    eus: 'Jarraitu eta zituen hobea egin duzu. 💪',
    pt: 'Continue esforçando-se e vai ficar cada vez melhor. 💪'
  },

  GOOD_QUIZZ_RESULT_SUBTITLE_3: {
    es: 'Tu resultado refleja tu dedicación. ¡Sigue así!',
    en: 'Your result reflects your dedication. ¡Keep going!',
    cat: 'El teu resultat reflecteix el teu esforç. ¡Continúa!',
    eus: 'Emaitza zure egarpena erakusten du. Jarraitu!',
    pt: 'O seu resultado reflete a sua dedicação. Continue!'
  },

  GOOD_QUIZZ_RESULT_SUBTITLE_4: {
    es: '¡Estás superando límites. ¡Vamos por más!',
    en: '¡You are exceeding limits. ¡Let’s go for more!!',
    cat: '¡Estàs superant límits. ¡Vam a fer més!!',
    eus: '¡Mugak gainditzen ari zara. Goazen gehiagoren bila!',
    pt: '¡Está a ultrapassar limites. Vamos em busca de mais!'
  },

  GOOD_QUIZZ_RESULT_SUBTITLE_5: {
    es: 'Este es solo el comienzo de grandes cosas. 💪',
    en: 'This is only the beginning of great things. 💪',
    cat: 'Això és només el començament de grans coses. 💪',
    eus: 'Hau gauza handien hasiera besterik ez da. 💪',
    pt: 'Este é o início de grandes coisas. 💪'
  },

  REGULAR_QUIZZ_RESULT_1: {
    es: '¡No estás mal!',
    en: '¡You are not bad!',
    cat: '¡No estàs mal!',
    eus: '¡Ez dago zaila!',
    pt: '¡Não está mal!'
  },

  REGULAR_QUIZZ_RESULT_2: {
    es: 'Paso a paso',
    en: 'Step by step',
    cat: 'Passo a passo',
    eus: 'Ziklo ziklo',
    pt: 'Passo a passo'
  },

  REGULAR_QUIZZ_RESULT_3: {
    es: 'Buen avance',
    en: 'Good progress',
    cat: 'Bon avanç',
    eus: 'Orokorra',
    pt: 'Bom progresso'
  },

  REGULAR_QUIZZ_RESULT_4: {
    es: 'Sigue intentándolo!',
    en: 'Keep trying!',
    cat: 'Segueix intentant-ho!',
    eus: 'Jarraitu!',
    pt: 'Continue tentando!'
  },

  REGULAR_QUIZZ_RESULT_5: {
    es: 'No bajes los brazos',
    en: 'Don’t give up!',
    cat: 'No t’arrendis!',
    eus: 'Ezabatu ezin duzu!',
    pt: 'Não desista!'
  },

  REGULAR_QUIZZ_RESULT_SUBTITLE_1: {
    es: 'Sigue esforzándote y lo harás cada vez mejor. 💪',
    en: 'Keep trying and you will get better and better. 💪',
    cat: 'Segueix esforçant-te i ho faràs cada vegada millor. 💪',
    eus: 'Jarraitu eta zituen hobea egin duzu. 💪',
    pt: 'Continue esforçando-se e vai ficar cada vez melhor. 💪'
  },

  REGULAR_QUIZZ_RESULT_SUBTITLE_2: {
    es: 'Refuerza lo que necesitas y verás cómo mejoras.',
    en: 'Strengthen what you need and you will see how you improve.',
    cat: 'Reforça el que necessites i veurem com milloris.',
    eus: 'Eragina zure behar duzun eta ikusi nire egin duzun.',
    pt: 'Reforce o que precisa e verá que melhora.'
  },

  REGULAR_QUIZZ_RESULT_SUBTITLE_3: {
    es: 'Cada intento estás más cerca del éxito.',
    en: 'Each attempt is closer to success.',
    cat: 'Cada intent estàs més a prop del èxit.',
    eus: 'Bakoitzeko saiakera zure emaitza hobea da.',
    pt: 'Cada tentativa está mais perto do sucesso.'
  },

  REGULAR_QUIZZ_RESULT_SUBTITLE_4: {
    es: 'Con un poco más de práctica, puedes llegar muy lejos.',
    en: 'With a little more practice, you can go very far.',
    cat: 'Amb un poc més de pràctica, pots anar molt lluny.',
    eus: 'Praktika pixka bat gehiagorekin, oso urrutira joan zaitezke.',
    pt: 'Com um pouco mais de prática, pode ir longe.'
  },

  REGULAR_QUIZZ_RESULT_SUBTITLE_5: {
    es: 'Repasa tus errores y sigue avanzando.',
    en: 'Review your mistakes and keep going.',
    cat: 'Revisa els teus errors i segueix avançant.',
    eus: 'Ezabatu zure erroak eta jarraitu.',
    pt: 'Revise seus erros e continue.'
  },

  BAD_QUIZZ_RESULT_1: {
    es: 'Roma no se construyó en un día',
    en: 'Rome was not built in a day',
    cat: 'Roma no es va construir en un dia',
    eus: 'Rome ezin da egunetik egin',
    pt: 'Roma não foi construída em um dia'
  },

  BAD_QUIZZ_RESULT_2: {
    es: '¡No te rindas!',
    en: '¡Don’t give up!',
    cat: '¡No t’arrendis!',
    eus: '¡Ezabatu ezin duzu!',
    pt: '¡Não desista!'
  },

  BAD_QUIZZ_RESULT_3: {
    es: '¡Ánimo!',
    en: '¡Keep trying!',
    cat: '¡Segueix intentant-ho!',
    eus: '¡Jarraitu!',
    pt: 'Continue tentando!'
  },

  BAD_QUIZZ_RESULT_4: {
    es: 'Sigue intentándolo',
    en: 'Keep trying',
    cat: 'Segueix intentant-ho',
    eus: 'Jarraitu',
    pt: 'Continue tentando'
  },

  BAD_QUIZZ_RESULT_5: {
    es: 'Sigue practicando',
    en: 'Keep practicing',
    cat: 'Segueix practicant',
    eus: 'Jarraitu praktika',
    pt: 'Continue praticando'
  },

  BAD_QUIZZ_RESULT_SUBTITLE_1: {
    es: '¡Sigue intentándolo y acabarás consiguiéndolo!',
    en: '¡Keep trying and you will succeed!',
    cat: '¡Segueix intentant-ho i acabaràs aconseguint-ho!',
    eus: '¡Jarraitu eta lortuko duzu!',
    pt: '¡Continue tentando e você vai conseguir!'
  },

  BAD_QUIZZ_RESULT_SUBTITLE_2: {
    es: 'Aprender de los errores es clave para triunfar.',
    en: 'Learning from mistakes is key to success.',
    cat: 'Aprendre dels errors és clau per aconseguir èxit.',
    eus: 'Erroreak ezagutzea ezin da egunetik egin',
    pt: 'Aprender com os erros é essencial para o sucesso.'
  },
  BAD_QUIZZ_RESULT_SUBTITLE_3: {
    es: 'Cada error es una oportunidad de aprendizaje. 💪',
    en: 'Each mistake is an opportunity for learning. 💪',
    cat: 'Cada error és una oportunitat d’aprenentatge. 💪',
    eus: 'Bakoitzeko errorea ikasten duzu. 💪',
    pt: 'Cada erro é uma oportunidade de aprendizado. 💪'
  },
  BAD_QUIZZ_RESULT_SUBTITLE_4: {
    es: 'Cada paso te acerca a tu meta. ¡Dale caña!',
    en: 'Each step brings you closer to your goal. ¡Keep going!',
    cat: 'Cada pas és més a prop de la teva meta. Continúa!',
    eus: 'Bakoitzeko ziklo zure helburu hobea da. Jarraitu!',
    pt: 'Cada passo te leva mais perto do seu objetivo. Continue!'
  },
  BAD_QUIZZ_RESULT_SUBTITLE_5: {
    es: 'Aún cuando te equivocas estás aprendiendo.',
    en: 'Even when you are wrong, you are learning.',
    cat: 'Mai estàs equivocat i aprendes.',
    eus: 'Ezabatu dituzke 1 puntu (edo balioa zehazten duen konvocatoria).',
    pt: 'As respostas incorrectas penalizam (normalmente subtraem 1/3 ou 1/4 do valor de uma resposta correcta).'
  },

  RESULTS: {
    es: 'Resultados',
    en: 'Results',
    cat: 'Resultats',
    eus: 'Emaitzak',
    pt: 'Resultados'
  },
  QUESTIONS: {
    es: 'Preguntas',
    en: 'Questions',
    cat: 'Preguntes',
    eus: 'Galderak',
    pt: 'Perguntas'
  },
  CORRECTS: {
    es: 'Correctas',
    en: 'Correct',
    cat: 'Correctes',
    eus: 'Egiaztatu dituzke',
    pt: 'Corretas'
  },
  CORRECTS_MESSAGE: {
    es: 'Las respuestas correctas suman 1 punto (o el valor que indique la convocatoria).',
    en: 'Correct answers sum 1 point (or the value indicated by the convocation).',
    cat: 'Les respostes correctes sumen 1 punt (o el valor que indiqui la convocatòria).',
    eus: 'Egiaztatu dituzke 1 puntu (edo balioa zehazten duen konvocatoria).',
    pt: 'As respostas corretas somam 1 ponto (ou o valor indicado pela convocação).'
  },
  INCORRECTS: {
    es: 'Incorrectas',
    en: 'Incorrect',
    cat: 'Incorrectes',
    eus: 'Ezabatu dituzke',
    pt: 'Incorrectas'
  },
  INCORRECTS_MESSAGE: {
    es: 'Las respuestas incorrectas penalizan (normalmente restan 1/3 o 1/4 del valor de una respuesta correcta).',
    en: 'Incorrect answers penalize (usually they subtract 1/3 or 1/4 of the value of a correct answer).',
    cat: 'Les respostes incorrectes penalitzen (normalment resten 1/3 o 1/4 del valor d’una resposta correcta).',
    eus: 'Ezabatu dituzke 1 puntu (edo balioa zehazten duen konvocatoria).',
    pt: 'As respostas incorrectas penalizam (normalmente subtraem 1/3 ou 1/4 do valor de uma resposta correcta).'
  },
  BLANKS: {
    es: 'En blanco',
    en: 'In blank',
    cat: 'En blanc',
    eus: 'Ezabatu dituzke',
    pt: 'Em branco'
  },
  BLANKS_MESSAGE: {
    es: 'Las preguntas en blanco no afectan la nota.',
    en: 'Blank questions do not affect the score.',
    cat: 'Les preguntes en blanc no afecten la nota.',
    eus: 'Galdera hutsek ez dute kalifikazioan eragiten',
    pt: 'As questões em branco não afetam a nota.'
  },
  TIME_TAKEN: {
    es: 'Tiempo',
    en: 'Time',
    cat: 'Temps',
    eus: 'Denbora',
    pt: 'Tempo'
  },
  ANSWERS_CORRECT: {
    es: 'Has acertado {{count}} de {{total}} preguntas',
    en: 'You got {{count}} of {{total}} questions right',
    cat: 'Has acertat {{count}} de {{total}} preguntes',
    eus: 'Zituen egiaztatu {{count}} galdera',
    pt: 'Acertou {{count}} de {{total}} perguntas'
  },

  RETRY: {
    es: 'Repetir test',
    en: 'Repeat test',
    cat: 'Repetir test',
    eus: 'Berriro egin testua',
    pt: 'Repetir teste'
  },

  RETRY_WRONGS: {
    es: 'Repetir incorrectas',
    en: 'Repeat incorrect',
    cat: 'Repetir incorrectes',
    eus: 'Berriro egin galdera ezabak',
    pt: 'Repetir erradas'
  },

  TOOLTIP_CORRECT: {
    es: 'Aciertos',
    en: 'Correct',
    cat: 'Correctes',
    eus: 'Egiaztatu dituzke',
    pt: 'Corretas'
  },
  TOOLTIP_INCORRECT: {
    es: 'Fallos',
    en: 'Incorrect',
    cat: 'Incorrectes',
    eus: 'Ezabatu dituzke',
    pt: 'Incorrectas'
  },

  TRIES: {
    es: 'Hecho {{tries}}',
    en: 'Done {{tries}}',
    cat: 'Fet {{tries}}',
    eus: 'Egin {{tries}}',
    pt: 'Feito {{tries}}'
  },

  TIMES_TRIES: {
    es: 'veces',
    en: 'times',
    cat: 'vegades',
    eus: 'bider',
    pt: 'vezes'
  },

  TIME_TRIES: {
    es: 'Vez',
    en: 'Time',
    cat: 'Temps',
    eus: 'Denbora',
    pt: 'Tempo'
  },

  SECTIONS: {
    es: 'Temas examinados',
    en: 'Sections',
    cat: 'Temes examinats',
    eus: 'Gaiak egiaztatu dituzke',
    pt: 'Temas examinados'
  },

  CHECK_ANSWERS: {
    es: 'Revisa tus respuestas',
    en: 'Check your answers',
    cat: 'Revisa les teves respostes',
    eus: 'Egiaztatu zure erantzunak',
    pt: 'Revisar suas respostas'
  },
  MAKE_ANOTHER_QUIZ: {
    es: 'Otro test',
    en: 'Another test',
    cat: 'Un altre test',
    eus: 'Beste testua',
    pt: 'Outro teste'
  },
  SEE_MY_PROGRESS: {
    es: 'Ver mi progreso',
    en: 'See my progress',
    cat: 'Veure el meu progrés',
    eus: 'Ikusi nire progresua',
    pt: 'Ver meu progresso'
  },

  SEE_MORE: {
    es: 'Ver más',
    en: 'See more',
    cat: 'Veure més',
    eus: 'Ikusi gehiago',
    pt: 'Ver mais'
  },

  SEE_LESS: {
    es: 'Ver menos',
    en: 'See less',
    cat: 'Veure menys',
    eus: 'Ikusi menos',
    pt: 'Ver menos'
  },

  RETRY_ERROR_TITLE: {
    es: 'Error',
    en: 'Error',
    cat: 'Error',
    eus: 'Errorea',
    pt: 'Erro'
  },

  RETRY_ERROR_MESSAGE: {
    es: 'Error al crear el test de repaso',
    en: 'Error creating the review test',
    cat: 'Error al crear el test de repaso',
    eus: 'Errorea egin duzu testuaren berreikin',
    pt: 'Erro ao criar o teste de revisão'
  }
};
